export const WIDGET_ERROR_MODAL_TITLE = 'Validation error';
